import Vue from 'vue'

const API = 'http://www.euroflam.co.uk/umbraco/EuroflamAPI/OrdersApi/'

export default class CustomerDataService {

  getBody (result) {
    if (result && result.body) {
      return result.body
    }
  }

  transformServerDate (ts) {
    return (ts + 1461) * 86400
  }

  toTimestamp (date){
    var datum = new Date(date);
    return datum.getTime()/1000;
   }

  transformClientDate (dateTime) {
    // convert dateTime to ts
    let ts = this.toTimestamp(dateTime)
    return Math.floor((ts / 86400) - 1461)
  }

  async getOrders ({ accountId, from, to, orderNumber }) {
    let tFrom = (from) ? this.transformClientDate(from) : from
    let tTo = (to) ? this.transformClientDate(to) : to
    let query = ``;
    if (tFrom > 0) query += `&from=${tFrom}`
    if (tTo > 0) query += `&to=${tTo}`
    if (orderNumber) query += `&orderNumber=${encodeURI(orderNumber)}`
    try {
      let result = await Vue.http.get(`${API}getOrders?accountId=${accountId}${query}`)
      return this.getBody(result)
        .map(row => ({
          ...row,
          date: this.transformServerDate(row.ordered),
          invoice: (!row.invoiceDate || row.invoiceDate === 0) ? '0' : this.transformServerDate(row.invoiceDate)
        }))
    } catch (error) { 
      console.log(error)
      return false
    }
  }

  async login ({ username, password }) {
    let url = `${API}login`
    let data = {
      username,
      password
    }
    try {
      let result = await Vue.http.post(url, data, {
        emulateJSON: true
      })
      return this.getBody(result)
    } catch (error) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/customer-data.js